<template>
  <div class="userPage">
    <div class="user_info">
      <div class="user flex-rowl">
        <div class="tx flex-rowc">
          <van-image
            width="98%"
            height="98%"
            round
            :src="
              userInfo.headimg
                ? userInfo.headimg
                : require('../../assets/images/user-tx.png')
            "
          />
        </div>
        <div class="main">
          <div class="nick">
            {{ userInfo.nickname ? userInfo.nickname : "" }}
          </div>
          <div class="name">
            {{ userInfo.truename ? userInfo.truename : "" }}
          </div>
          <div class="leavel_accountId flex-rowl">
            <p>
              {{ userInfo.levelid ? "LV-" + userInfo.levelid : "" }} |
              {{ userInfo.attrname ? userInfo.attrname : "" }}
            </p>
            <!-- <p class="accountId">
              ID：{{ userInfo.accountid ? userInfo.accountid : "" }}
            </p> -->
            <div
              class="copy_box"
              :data-clipboard-text="userInfo.accountid"
              @click="handleCopyBtn()"
            >
              <i class="iconfont icon-fuzhi"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="line"></div>

    <div class="base_info">
      <div class="tit">个人信息</div>
      <div class="base_info_list">
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-xingmingyonghumingnicheng"></i>
            </div>
            姓名：
          </div>
          <div class="txt2">{{ userInfo.truename }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-shoujihaoma"></i>
            </div>
            工作手机：
          </div>
          <div class="txt2">{{ tuozhan.mobile }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-weixin"></i>
            </div>
            工作微信：
          </div>
          <div class="txt2">{{ tuozhan.weixin }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-gender"></i>
            </div>
            性别：
          </div>
          <div class="txt2">{{ userInfo.sex ? userInfo.sex : "" }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-nianling"></i>
            </div>
            年龄：
          </div>
          <div class="txt2">{{ userInfo.age ? userInfo.age : "" }}</div>
        </div>
        <div class="base_info_item base_info_item_address">
          <div class="txt1 flex-rowl">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-weibiaoti-3"></i>
            </div>
            所在地区（日常活动范围）
          </div>
          <div class="txt">
            <p>
              <span v-if="PCA_address">{{ PCA_address }}</span>
              <span v-else class="place">省、市、自治区</span>
            </p>
            <p>
              <span v-if="userInfo.addr">{{ userInfo.addr }}</span>
              <span v-else class="place">区、街道、详细地址</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="other_wrap" v-if="qy.checkstate == '已通过'">
      <div class="depar_role_wrap">
        <div class="tit">部门及角色设置：</div>
        <div class="from_wrap">
          <div class="select flex-between" @click="handleDepartment">
            <van-field v-model="department" placeholder="选择部门" readonly />
            <i class="iconfont icon-yuyinjiantou"></i>
          </div>
          <div class="select flex-between" @click="handleRole">
            <van-field v-model="role" placeholder="选择角色" readonly />
            <i class="iconfont icon-yuyinjiantou"></i>
          </div>
        </div>
        <div
          class="save custom_btn"
          @click="handleSubmitDepRole"
          v-if="userInfo.rolename != '创建人'"
        >
          保存
        </div>
      </div>
      <div
        class="remove_btn custom_btn"
        @click="handleRemove"
        v-if="userInfo.rolename != '创建人'"
      >
        移出企业/团队 <i class="iconfont icon-guanbi"></i>
      </div>
    </div>

    <div class="apply_operation_wrap" v-if="qy.checkstate == '审核中'">
      <div class="content">
        <div class="txt1">申请加入时间：</div>
        <div class="txt2">{{ userInfo.createdate }}</div>
      </div>
      <div class="default_btn custom_btn" @click="handleAgree">
        同意加入申请 <i class="iconfont icon-duihao"></i>
      </div>
      <div class="remove_btn custom_btn" @click="handleRefuse">
        拒绝加入申请 <i class="iconfont icon-guanbi"></i>
      </div>
    </div>

    <div class="custom_btn return" @click="handlereturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div>

    <van-dialog v-model="isShow" title="部门及角色关系管理" show-cancel-button>
      <!-- @confirm="handleSubmitDepRole" -->
      <div class="dialog_wrapper">
        <div class="select_box flex-between" @click="handleDepartment">
          <van-field v-model="department" placeholder="请选择部门" readonly />
          <i class="iconfont icon-bottom"></i>
        </div>
        <div class="select_box flex-between" @click="handleRole">
          <van-field v-model="role" placeholder="请选择角色关系" readonly />
          <i class="iconfont icon-bottom"></i>
        </div>
      </div>
    </van-dialog>

    <van-popup
      v-model="isShowPopup"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div v-if="selectType == 1">
        <van-picker
          show-toolbar
          :columns="departList"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
        />
      </div>
      <div v-else-if="selectType == 2">
        <van-picker
          show-toolbar
          :columns="roleList"
          @confirm="onConfirm"
          @cancel="isShowPopup = false"
        />
      </div>
    </van-popup>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import { getUserInfo, encryptstringview } from "../../api/api";
import {
  refuseApply,
  acceptApply,
  getDeptList,
  getDeptRole,
  setUserDepRole,
  userRemoveCompany,
  getQyNoticeList,
  editQyNotice,
} from "../../api/company";
import { mapState } from "vuex";
export default {
  name: "userDetail",
  data() {
    return {
      isShow: false,
      department: "",
      departmentId: "",
      departList: [],
      role: "",
      roleId: "",
      roleList: [],
      isShowPopup: false,
      selectType: 1, // 1、部门，2、角色

      PCA_address: "", // 省、市、区
      userInfo: "",
      tuozhan: "",
      works: "",
      qy: "",

      openid: "",
      id: "",
      qyid: "",

      noticeId: "",
      qyguid: "",
      noticeObj: {
        mobile_user: "",
        mobile_cmuser: "",
        mobile_sendgoods: "",
        mobile_checkreturn: "",
      },
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { openid, qyid, id } = JSON.parse(res.jsondata);
        this.id = id;
        this.openid = openid;
        this.qyid = qyid;
        this.getUserInfo();
        this.getDeptList();
      } else {
        this.$router.back();
      }
    },

    getUserInfo() {
      let { openid } = this;
      getUserInfo({ openid }).then((res) => {
        console.log(res, "======resresresres");
        this.userInfo = res;
        this.PCA_address =
          (res.provincename ? res.provincename : "") +
          " " +
          (res.cityname ? res.cityname : "") +
          " " +
          (res.areaname ? res.areaname : "");
        this.tuozhan = res.tuozhan.length == 0 ? "" : res.tuozhan[0];
        this.works = res.works == 0 ? "" : res.works[0];
        this.qy = res.qy;
        this.department = res.deptname;
        this.departmentId = res.deptid;
        this.role = res.rolename;
        this.roleId = res.roleid;
        this.getQyNoticeList();
      });
    },

    // 获取企业业务设置
    getQyNoticeList() {
      getQyNoticeList({ qyguid: this.qyguid }).then((res) => {
        if (res.list.length != 0) {
          let newRes = res.list[0];
          this.noticeId = newRes.id;
          this.noticeObj.mobile_user = newRes.mobile_user
            ? newRes.mobile_user
            : "";
          this.noticeObj.mobile_cmuser = newRes.mobile_cmuser
            ? newRes.mobile_cmuser
            : "";
          this.noticeObj.mobile_sendgoods = newRes.mobile_sendgoods
            ? newRes.mobile_sendgoods
            : "";
          this.noticeObj.mobile_checkreturn = newRes.mobile_checkreturn
            ? newRes.mobile_checkreturn
            : "";
        }

        for (let key in this.noticeObj) {
          if (
            this.noticeObj[key] ===
            this.userInfo.truename + " | " + this.userInfo.mobile
          ) {
            this.noticeObj[key] = "";
          }
        }
      });
    },

    // 修改企业业务设置
    editQyNotice() {
      let { noticeObj } = this;
      let obj = {
        id: this.noticeId,
        qyguid: this.qyguid,
      };
      let mergedObj = { ...obj, ...noticeObj };

      editQyNotice(mergedObj).then((res) => {
        console.log(res, "--==--=");
      });
    },

    // 同意
    handleAgree() {
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      let { id, qyid } = this;
      acceptApply({ qyid, logid: id }).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          this.getUserInfo();
        } else {
          toast.clear();
        }
      });
    },

    // 拒绝
    handleRefuse() {
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      let { id, qyid } = this;
      refuseApply({ qyid, logid: id }).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          this.getUserInfo();
        } else {
          toast.clear();
        }
      });
    },

    // 移出企业
    handleRemove() {
      this.$dialog
        .confirm({
          message: "是否确定移出该成员",
        })
        .then(() => {
          this.userRemoveCompany();
        })
        .catch(() => {
          // on cancel
          console.log("2222");
        });
    },
    userRemoveCompany() {
      const toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      let { id, qyid } = this;
      userRemoveCompany({ qyid, logid: id }).then((res) => {
        if (res.result) {
          toast.clear();
          this.$toast.success(res.message);
          this.editQyNotice();
          setTimeout(() => {
            this.$router.back();
          }, 1500);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },

    //  获取部门
    getDeptList() {
      getDeptList().then((res) => {
        let newArr = [];
        res.filter((v) => {
          if (v.deptstate) {
            newArr.push({
              text: v.deptname,
              id: v.deptid,
            });
          }
        });
        this.departList = newArr;
      });
    },
    // 触发部门
    handleDepartment() {
      let { roleId } = this;
      if (roleId == 1) {
        return;
      }
      this.isShowPopup = true;
      this.selectType = 1;
    },
    // 获取角色
    getDeptRole() {
      let { departmentId } = this;
      getDeptRole({ deptid: departmentId }).then((res) => {
        let newArr = [];
        res.filter((v) => {
          if (v.isuse && v.roleid != 1) {
            newArr.push({
              text: v.rolename,
              id: v.roleid,
            });
          }
        });
        this.roleList = newArr;
        if (newArr.length > 0) {
          this.isShowPopup = true;
        } else {
          this.$toast("暂无角色");
        }
      });
    },

    // 触发角色
    handleRole() {
      let { departmentId, roleId } = this;
      if (roleId == 1) {
        return;
      }
      if (departmentId == "") {
        this.$toast("请选择部门");
        return;
      }
      this.selectType = 2;
      this.getDeptRole();
    },

    onConfirm(e) {
      let { selectType } = this;
      if (selectType == 1) {
        this.departmentId = e.id;
        this.department = e.text;
        this.roleId = "";
        this.role = "";
      } else if (selectType == 2) {
        this.roleId = e.id;
        this.role = e.text;
      }
      this.isShowPopup = false;
    },

    handleShowRole() {
      this.isShow = true;
    },

    // 管理员对用户进行部门和角色的分配
    handleSubmitDepRole() {
      let { departmentId, roleId, userInfo } = this;
      const toast = this.$toast.loading({
        message: "修改中...",
        forbidClick: true,
      });
      let params = {
        openid: userInfo.openid,
        deptid: departmentId,
        roleid: roleId,
      };
      setUserDepRole(params).then((res) => {
        if (res.result) {
          this.$toast.success(res.message);
          setTimeout(() => {
            toast.clear();
            this.$router.back();
          }, 1000);
        } else {
          this.$toast.fail(res.message);
          toast.clear();
        }
      });
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },

    // 返回上一页
    handlereturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.userPage {
  padding-bottom: 350px;
  background: #fafafa;
  .dialog_wrapper {
    padding: 80px 50px;
    box-sizing: border-box;
    .select_box {
      width: 100%;
      margin-bottom: 40px;
    }
  }
  .user_info {
    padding: 45px 40px 0;
    margin: auto;
    background: #fff;
    .tx {
      width: 140px;
      height: 140px;
      border: 5px solid #f0f0f0;
      box-sizing: border-box;
      border-radius: 50%;
      margin-right: 25px;
      position: relative;
      .edit {
        position: absolute;
        bottom: 7px;
        right: 9px;
        background: #f0f0f0;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        .iconfont {
          font-size: 12px;
        }
      }
    }
    .main {
      flex: 1;
      .nick {
        font-size: 22px;
        color: #828282;
      }
      .name {
        font-size: 30px;
        color: #3c3c3c;
        margin: 12px 0 14px;
      }
      .leavel_accountId {
        font-size: 16px;
        color: #aaaaaa;
        .accountId {
          margin: 0 13px 0 45px;
        }
      }
    }
  }
  .line {
    background: url(../../assets/images/mime_line.png) no-repeat center;
    background-size: cover;
    width: 750px;
    height: 86px;
  }

  .base_info {
    background: #fff;
    padding: 29px 83px 100px;
    box-sizing: border-box;
    font-size: 24px;
    color: #333333;
    .tit {
      font-size: 30px;
      margin-bottom: 60px;
    }
    .base_info_item {
      margin-bottom: 60px;
      &.base_info_item_address {
        .txt {
          margin-left: 40px;
          p {
            margin: 20px 0;
            .place {
              color: #969799;
            }
          }
        }
      }
    }
  }

  .depar_role_wrap {
    margin: 30px 0 90px;
    background: #fff;
    padding: 50px 75px 80px;
    box-sizing: border-box;
    .tit {
      font-size: 30px;
      color: #333333;
      margin-bottom: 80px;
    }
    .select {
      border-bottom: 1px dashed #c3c3c3;
      height: 60px;
      margin-bottom: 40px;
      &:last-child {
        margin-bottom: 0;
      }
      .icon-yuyinjiantou {
        transform: rotate(-90deg);
        font-size: 30px;
      }
    }

    /deep/ .van-cell {
      padding: 0 14px !important;
      font-size: 12px;
    }
  }
  .apply_operation_wrap {
    padding: 80px 0 115px 0;
    box-sizing: border-box;
    border-bottom: 30px solid #fff;
    margin-bottom: 30px;
    .content {
      // padding-left: 82px;
      box-sizing: border-box;
      font-size: 30px;
      color: #333333;
      text-align: center;
      .txt2 {
        font-size: 22px;
        margin-top: 25px;
      }
    }
    .default_btn {
      margin: 84px auto 57px;
    }
  }
  .save {
    color: #fff;
    margin-top: 100px;
    width: 280px;
    height: 50px;
    line-height: 50px;
  }
  .remove_btn {
    border: 1px solid #e6e6e6;
    color: #373737;
    background: #fff;
    margin-bottom: 40px;
  }
}
</style>